import { ISetting } from '@/types'

export const baseSettings: Partial<ISetting> = {
  app: {
    version: process.env.NEXT_PUBLIC_APP_VERSION,
  },
  images: {
    storeLogo: {
      google: '/assets/images/general/logos/google.svg',
      apple: '/assets/images/general/logos/apple.svg',
    },
    storeButton: {
      google: '/assets/images/general/stores/google_play.webp',
      apple: '/assets/images/general/stores/apple_store.webp',
    },
  },
  firebase: {
    config: {
      apiKey: "AIzaSyAjjGxUCrYIb4DlmI-64grZ8kLt6HrBXhU",
      authDomain: "fanatiz-app.firebaseapp.com",
      databaseURL: "https://fanatiz-app.firebaseio.com",
      projectId: "fanatiz-app",
      storageBucket: "fanatiz-app.appspot.com",
      messagingSenderId: "209258384937",
      appId: "1:209258384937:web:ea2f7ede9d2295a8721638",
      measurementId: "G-ZGZQ1VKBGZ",
    },
  },
  theoPlayer: {
    license: 'sZP7IYe6T6Pl3l4l3lftCmz_3L1KFSa_0lh-CK36Tmzi0Let0oXKClbz0la6FOPlUY3zWokgbgjNIOf9fKfi0KCzTuXlFDhiTQa-3ufi3Zk63QhoFDB_IK31CoBoCle_0OfVfK4_bQgZCYxNWoryIQXzImf90SRZ3LCk3Sfi0u5i0Oi6Io4pIYP1UQgqWgjeCYxgflEc3Lft0SCk0lhk0ufZFOPeWok1dDrLYtA1Ioh6TgV6v6fVfKcqCoXVdQjLUOfVfGxEIDjiWQXrIYfpCoj-fgzVfKxqWDXNWG3ybojkbK3gflNWf6E6FOPVWo31WQ1qbta6FOPzdQ4qbQc1sD4ZFK3qWmPUFOPLIQ-LflNWfK1zWDikfgzVfG3gWKxydDkibK4LbogqW6f9UwPkImi6IK41Uw4ZIY06Tg-Uya',
  },
  recaptcha: {
    key: '6LfIiZUmAAAAALPlItkWYzXiPQvPpOlVDzMRM_CW',
  },
  sentry: {
    dsn: 'https://d092fb3159f117c9d709479dec6e8963@o4508688718626816.ingest.us.sentry.io/4510465883045888',
  },
  debug: process.env.NEXT_PUBLIC_DEBUG === 'true' ? true : false,
}

// Environment overrides for general settings
export const envOverrides: Record<string, Partial<ISetting>> = {
  development: {
    recurly: {
      domain: 'https://fzsportstaging.recurly.com/subscribe/',
      publicKey: 'ewr1-ulTNDEtRTCUC8zIaQi5zdS'
    },
    kushki: {
      merchantId: 'c7edf197f0034886ba4d230c5609c8c7',
      inTestEnvironment: true,
    },
    dlocal: {
      publicKey: 'b1ff8c5a-ee22-44b1-953d-5024f7c954b2'
    }
  },
  staging: {
    recurly: {
      domain: 'https://fzsports.recurly.com/subscribe/',
      publicKey: 'ewr1-N5UeUH6zYhu4ph7OjoeUQR',
    },
  },
  production: {
    recurly: {
      domain: 'https://fzsports.recurly.com/subscribe/',
      publicKey: 'ewr1-N5UeUH6zYhu4ph7OjoeUQR',
    },
  },
}